import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';
import { environment } from '../../environtment/environtment';
// import { LoginModel } from "../core/models/login.model";

// import * as moment from 'moment';

@Injectable()

export class ServicesProvider {
    api_url_mail = environment.api_url_mail;
    api_url = environment.api_nestjs; // local

    constructor(private httpClient: HttpClient) {
    }

    // login(body: LoginModel): Observable<any> {
    //     const headers = {
    //         'Content-Type': 'application/json',
    //         'Accept': 'application/json'
    //     };
    //     return this.httpClient.post(this.api_url + '/auth/login', body, { headers });
    // }

    mail(para: any): Observable<any> {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        };
        return this.httpClient.get(this.api_url_mail + para, { headers });
    }

    getDatalinegraph(body: any): Observable<any> {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };
        return this.httpClient.post<any>(`${this.api_url}/graph/graphLine`, body);
    }

    getDataStackedgraph(body: any): Observable<any> {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };
        return this.httpClient.post<any>(`${this.api_url}/graph/graphStack`, body);
    }

    getProgressMeter(meter: number): Observable<any> {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        };
        return this.httpClient.get<any>(`${this.api_url}/meter/getProgressMeter/` + meter);
    }

    getProgressType(): Observable<any> {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        };
        return this.httpClient.get<any>(`${this.api_url}/meter/getProgressType`);
    }

    getDataInverterList(site: number): Observable<any> {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };
        return this.httpClient.get(`${this.api_url}/meter/inverterlist/` + site, { headers });
    }


    getallLock(): Observable<any> {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };
        return this.httpClient.get(`${this.api_url}/meter/allDeviceList`, { headers });
    }

    getWaterSummary(id: number): Observable<any> {
        return this.httpClient.get<any>(`${this.api_url}/water/summary/` + id);
    }

    getWaterRecent(id: number): Observable<any> {
        return this.httpClient.get<any>(`${this.api_url}/water/recent/` + id);
    }

    getWaterUsage(body: any): Observable<any> {
        return this.httpClient.post<any>(`${this.api_url}/water/usage`, body);
    }

    addWaterReading(body: any): Observable<any> {
        return this.httpClient.post<any>(`${this.api_url}/water/reading`, body);
    }

    getEnergyLock(id: number): Observable<any> {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };
        return this.httpClient.get(`${this.api_url}/meter/getEnergyLock/` + id, { headers });
    }

    getallReport(date: string): Observable<any> {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };
        return this.httpClient.get(`${this.api_url}/report/allReport/` + date, { headers });
    }


    dowloadDataExcel(body: any): Observable<HttpResponse<Blob>> {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };
        return this.httpClient.post<Blob>(
            `${this.api_url}/report/dowloadReport`,
            body,
            { headers, responseType: 'blob' as 'json', observe: 'response' }
        );
    }



}


